import { storage, auth } from './firebase'
import {
    ref,
    uploadBytesResumable,
    getDownloadURL
} from 'firebase/storage'

/**
 * Upload multiple images for an identification session
 * @param {Array} images - Array of processed image objects { id, file, ... }
 * @param {string} sessionId - Unique ID for this identification session
 * @param {Function} onProgress - Callback for upload progress
 */
export async function uploadIdentificationImages(images, sessionId, onProgress) {
    const user = auth.currentUser
    if (!user) throw new Error('User must be authenticated')

    const uploadPromises = images.map(async (image, index) => {
        // Determine if this is the main view
        const isMain = image.isMain || false

        // Create storage reference
        // Path: images/{userId}/{sessionId}/{filename}
        const storageRef = ref(storage, `images/${user.uid}/${sessionId}/${image.id}-${image.name}`)

        // Start upload
        const uploadTask = uploadBytesResumable(storageRef, image.file)

        return new Promise((resolve, reject) => {
            uploadTask.on('state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    if (onProgress) onProgress(image.id, progress)
                },
                (error) => {
                    console.error(`Upload failed for ${image.name}:`, error)
                    reject(error)
                },
                async () => {
                    // Upload complete, get URL
                    const downloadURL = await getDownloadURL(uploadTask.snapshot.ref)
                    resolve({
                        id: image.id,
                        url: downloadURL,
                        isMain: isMain,
                        storagePath: storageRef.fullPath
                    })
                }
            )
        })
    })

    return Promise.all(uploadPromises)
}
